import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { userDevices, editDeviceName, logout} from 'src/app/shared/constants';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environment';
import { UikitService } from './uikit.service';

@Injectable({
  providedIn: 'root'
})
export class UserDevicesService {
  public devicesList = new BehaviorSubject([]);
  constructor(private http: HttpClient,private uikitService: UikitService,) { }

  getUserDevice(data: any): Observable<any> {
    const params = new HttpParams()
    const deviceUrl = environment.apiEndpoint + environment.version + userDevices;
    return this.http.get<any>(deviceUrl, { params }).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response;
        }
      }, (error: HttpErrorResponse) => {
        console.log(error);
      })
    );
  }

  removeUserDevice(url: any): Observable<any> {
    const params = new HttpParams()
    const deviceUrl = environment.apiEndpoint + environment.version + url;
    return this.http.get<any>(deviceUrl, {params}).pipe(
      map((response: any) => {
        if (response.status_code === 200) {
          return response;
        }
      }, (error: HttpErrorResponse) => {
        console.log(error);
      })
    );
  }

  editUserDeviceName(data):Observable<any>{
    const body ={
      device_name:data.newName,
      device_id:data.deviceId
  }
  const editDeviceNameUrl = environment.apiEndpoint + environment.version + editDeviceName;
  return this.http.post(editDeviceNameUrl, body).pipe(
    map((response:any)=>{
      if(response.status_code === 200){
        return response;
    }
    }), catchError((error)=>{
      return error
    })
  )
  }

  logoutDevice(data){
    const dId: string = data.device_id;
    const logoutAPI: string = environment.apiEndpoint + environment.version + logout + dId;
    const params: HttpParams = new HttpParams()
    return this.http.get<any>(logoutAPI, { params }).pipe(
      map((response:any)=>{
        if(response.status_code === 200){
          return response;
        }
      }), catchError((error)=>{
        this.uikitService.notifyError(error);
        return error;
      })
    )
  }

}
